// Key values that are repeated a lot
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  ACTUAL_CHANGE_WINDOW,
} from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
import {
  currentSelectedNetwork,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
// form fields
import { actualStartDate } from './actual-start-date';
import { actualEndDate } from './actual-end-date';
// sub section titles
import { actualChangeWindow } from './actual-change-window';

// callback for the form section to figure out what fields to render with conditional logic
const getSectionTwoCurrentFields = ({ readOnly, formData, isOLO } = {}) => {

  const scheduledStart = formData.dataByFormSectionId.START_AND_END_DATE.dataByFieldId['scheduled-start-date'].displayValues;
  const scheduledEnd = formData.dataByFormSectionId.START_AND_END_DATE.dataByFieldId['scheduled-end-date'].displayValues;
  const selectedNetwork = currentSelectedNetwork(formData);
  const currentFields = [
    {
      ...defaultFieldLogic,
      componentData: {
        ...actualChangeWindow,
      },
      shouldRender: !isOLO,
      // shouldValidate: !isOLO,
    },
    {
      ...defaultFieldLogic,
      componentData: {
        ...actualStartDate,
        vFParams: {
          ...actualStartDate.vFParams,
          selectedNetwork,
        },
      },
      readOnly,
      shouldRender: !isOLO,
      shouldValidate: !isOLO,
      overwriteSubmit: {
        overwrite: isOLO,
        overwriteValue: scheduledStart,
      },
    }, {
      ...defaultFieldLogic,
      componentData: {
        ...actualEndDate,
        vFParams: {
          ...actualEndDate.vFParams,
          selectedNetwork,
        },
      },
      readOnly,
      shouldRender: !isOLO,
      shouldValidate: !isOLO,
      overwriteSubmit: {
        overwrite: isOLO,
        overwriteValue: scheduledEnd,
      },
    },
  ];

  return currentFields;
};

export {
  getSectionTwoCurrentFields,
  ACTUAL_CHANGE_WINDOW,
};
